import React from 'react'
import { Range } from 'react-range'
import * as Styled from './Slider.styles'

export interface Props {
  min: number
  max: number
  step?: number
  value: number
  onValueChange: (v: number) => void
  size?: 'small' | 'medium' | 'large'
  isDisabled?: boolean
  isError?: boolean
  withMarks?: boolean
  withValue?: boolean
}

const Slider: React.FC<Props> = ({
  min,
  max,
  value,
  step = 1,
  onValueChange,
  size = 'medium',
  isDisabled,
  isError = false,
  withMarks = false,
  withValue = false,
}) => (
  <Range
    step={step}
    min={min}
    max={max}
    disabled={isDisabled}
    values={[value]}
    onChange={([v]) => onValueChange(v)}
    renderMark={({ props, index }) => withMarks && index !== 0 && index * step < max && <Styled.Mark size={size} {...props} />}
    renderTrack={({ props, children }) => (
      <Styled.Track size={size} {...props}>
        {children}
      </Styled.Track>
    )}
    renderThumb={({ props }) => (
      <Styled.Thumb {...props} isDisabled={isDisabled} isError={isError} size={size}>
        {withValue && <Styled.ThumbValue isError={!isDisabled && isError}>{value}</Styled.ThumbValue>}
      </Styled.Thumb>
    )}
  />
)

export default Slider
